import { Table } from "antd";
import type { ColumnsType, TablePaginationConfig } from "antd/es/table";

type TableProps = {
  columns: ColumnsType<any>;
  data: Array<any>;
  pagination: TablePaginationConfig;
  onSelectRow: any;
  selectedRowKey: any;
  selectionType: any;
  expandable?: any;
};

/**
 * 
 * 
 * pagination={{
        total: data.total,
        onChange: onPaginationChange,
        current: currentPagination,
      }}
 * 
 * =
 */

export const TableComponent = ({
  columns,
  data,
  pagination,
  onSelectRow,
  selectedRowKey,
  expandable,
}: TableProps) => {
  const selectionType = "radio";

  return (
    <Table
      columns={columns}
      dataSource={data}
      size="small"
      pagination={pagination}
      bordered
      rowSelection={{
        type: selectionType,
        selectedRowKeys:
          selectionType === "radio" ? [selectedRowKey] : selectedRowKey,
        onChange: onSelectRow,
      }}
      expandable={expandable}
    />
  );
};
